<template>
    <div class="org-zoom" :class="isInModal ? 'org-zoom--in-modal' : 'org-zoom--not-in-modal'">
        <a class="back-to-main" href="/whos-involved/" @click.prevent="handleBackClick" ref="link">Back to Engagement List</a>
        <div class="content-wrapper">
            <ul v-if="showPrevNext" class="org-zoom__prev-next prev-next">
                <li>
                    <a href="#previous" @click.prevent="handlePrevNextClick('prev')" class="prev-next__btn prev-next__btn--prev" :class="disablePrev ? 'prev-next__btn--disabled' : ''"><span class="sr-only">Go to previous</span></a>
                </li>
                <li>
                    <a href="#next" @click.prevent="handlePrevNextClick('next')" class="prev-next__btn prev-next__btn--next" :class="disableNext ? 'prev-next__btn--disabled' : ''"><span class="sr-only">Go to next</span></a>
                </li>
            </ul>
            <transition name="delay-fade-in">
                <div :key="org">
                    <div class="org-zoom__details m-b-spacer-sm">
                        <div class="org-zoom__details__left">
                            <h1>{{org.name}}</h1>
                            <div>
                                <p v-if="org.type.length > 0">
                                    <span class="org-zoom__details__key">Status:</span> <span class="org-zoom__details__value">{{ getTypeList(org.type) }}</span><br>
                                </p>
                                <p v-if="org.contact">
                                    <span class="org-zoom__details__key">Contact:</span> <span class="org-zoom__details__value">{{ org.contact }}</span><br>
                                </p>
                                <p v-if="org.website">
                                    <span class="org-zoom__details__key">Website:</span> <span class="org-zoom__details__value">
                                        <a :href="org.website" target="_blank" style="padding: 0 16px;">
                                            <svg width="23px" height="23px" viewBox="0 0 23 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="width: 16px; margin-bottom: -4px;">
                                                <title>Go to web page</title>
                                                <g id="Standards-&amp;-Initiatives" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                    <path d="M14.375,0 C13.5798828,0 12.9375,0.642382813 12.9375,1.4375 C12.9375,2.23261719 13.5798828,2.875 14.375,2.875 L18.0900391,2.875 L9.04726563,11.9222656 C8.48574219,12.4837891 8.48574219,13.3957031 9.04726563,13.9572266 C9.60878906,14.51875 10.5207031,14.51875 11.0822266,13.9572266 L20.125,4.90996094 L20.125,8.625 C20.125,9.42011719 20.7673828,10.0625 21.5625,10.0625 C22.3576172,10.0625 23,9.42011719 23,8.625 L23,1.4375 C23,0.642382813 22.3576172,0 21.5625,0 L14.375,0 Z M3.59375,1.4375 C1.60820312,1.4375 0,3.04570312 0,5.03125 L0,19.40625 C0,21.3917969 1.60820312,23 3.59375,23 L17.96875,23 C19.9542969,23 21.5625,21.3917969 21.5625,19.40625 L21.5625,14.375 C21.5625,13.5798828 20.9201172,12.9375 20.125,12.9375 C19.3298828,12.9375 18.6875,13.5798828 18.6875,14.375 L18.6875,19.40625 C18.6875,19.8015625 18.3640625,20.125 17.96875,20.125 L3.59375,20.125 C3.1984375,20.125 2.875,19.8015625 2.875,19.40625 L2.875,5.03125 C2.875,4.6359375 3.1984375,4.3125 3.59375,4.3125 L8.625,4.3125 C9.42011719,4.3125 10.0625,3.67011719 10.0625,2.875 C10.0625,2.07988281 9.42011719,1.4375 8.625,1.4375 L3.59375,1.4375 Z" id="arrow-up-right-from-square-solid" fill="#409BFF" fill-rule="nonzero"></path>
                                                </g>
                                            </svg>
                                        </a>
                                    </span><br>
                                </p>
                                <p v-if="org.is_member && org.member_since">
                                    <span class="org-zoom__details__key">Member Since:</span> <span class="org-zoom__details__value">{{ org.member_since }}</span>
                                </p>
                                <p v-else>
                                    <span class="org-zoom__details__key">Member:</span> <span class="org-zoom__details__value">{{ org.is_member ? 'Yes' : 'No' }}</span>
                                </p>
                                <a href="/membership/" class="arrow-link">Membership Info</a>
                            </div>
                        </div>
                        <div class="org-zoom__details__right">
                            <div class="org-zoom__details__logo" v-if="org.logo" :style="'background-image: url(' + org.logo.logo_image + ')'">
                            </div>
                        </div>
                    </div>
                    <div v-if="org.resiliency_statement.statement" class="resiliency-statement m-b-spacer-sm">
                        <h2>Resiliency Statement</h2>
                        <p class="resiliency-statement__quote">“{{ org.resiliency_statement.statement }}”</p>
                        <p v-if="org.resiliency_statement.source" class="resiliency-statement__source">— {{ org.resiliency_statement.source }}</p>
                    </div>
                    <div v-if="org.display_engagement_info" class="org-zoom__scorecard">
                        <div v-if="false">
                            <!-- <div class="org-zoom__details__left">
                                <div class="display-flex" style="align-items: baseline;">
                                    <h2>Engagement</h2>
                                    <a href="#show-definitions" class="show-definitions m-l-spacer-sm" @click.prevent="showInfoModal = true">
                                        <svg width="18" height="18" viewBox="0 0 18 18"><use xlink:href="#icon--circle-question"></use></svg>
                                        Show Definitions
                                    </a>
                                </div>
                                <h3>Score Card</h3>
                                <p class="engagement-label">
                                    <engagement-icon :engagement="org.engagement.scorecard" class="engagement-icon"></engagement-icon>
                                    <span :class="getColorClass(org.engagement.scorecard)">{{ capFirstLetter(org.engagement.scorecard) }}</span>
                                </p>
                                <h3>Resiliency Lite Assessment</h3>
                                <p class="engagement-label">
                                    <engagement-icon :engagement="org.engagement.bcm_assessment" class="engagement-icon"></engagement-icon>
                                    <span :class="getColorClass(org.engagement.bcm_assessment)">{{ capFirstLetter(org.engagement.bcm_assessment) }}</span>
                                </p>
                                <h3>Mapping & Monitoring</h3>
                                <p class="engagement-label">
                                    <engagement-icon :engagement="org.engagement.mapping" class="engagement-icon"></engagement-icon>
                                    <span :class="getColorClass(org.engagement.mapping)">{{ capFirstLetter(org.engagement.mapping) }}</span>
                                </p>
                            </div> -->
                        </div>
                        <div v-if="showBadgesSection" class="org-zoom__details__right">
                            <div class="display-flex" style="align-items: baseline;">
                                <h2>Badges</h2>
                                <a href="#show-definitions" class="show-definitions m-l-spacer-sm" @click.prevent="showInfoModal = true">
                                    <svg width="18" height="18" viewBox="0 0 18 18"><use xlink:href="#icon--circle-question"></use></svg>
                                    Show Definitions
                                </a>
                            </div>
                            <div v-if="org.engagement?.badges?.transparency?.has_badge" class="m-b-spacer-sm">
                                <h3>Transparency</h3>
                                <img v-tooltip="'Transparency Badge: Partner ' + org.engagement.badges.transparency.version" class="org-zoom__badge org-zoom__badge--transparency" :src="getTranspYearBadge(org.engagement.badges.transparency.version)" alt="Transparency Badge" style="margin-left: -20px">
                            </div>
                            <div v-if="org.engagement?.badges?.resiliency?.has_badge" class="m-b-spacer-sm">
                                <h3>Resiliency</h3>
                                <resiliency-badge-details :badges-by-year="org.engagement.badges.resiliency.year_badges"></resiliency-badge-details>   
                            </div>
                            <div v-for="badge in badgesSupported" :key="badge">
                                <div v-for="(value, key) in badge" :key="key">
                                    <h3>{{ key }}</h3>
                                    <p class="engagement-label">
                                        <engagement-icon :engagement="value" class="engagement-icon"></engagement-icon>
                                        <span :class="getColorClass(value)">{{ capFirstLetter(value) }}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <modal :show-modal="showInfoModal" :is-nested-modal="true" @closeModal="showInfoModal = false">
            <engagement-definitions :org-types="org.type"></engagement-definitions>
        </modal>
    </div>
</template>

<script setup>
    import { ref, onMounted, computed, onBeforeUnmount } from 'vue'
    import EngagementIcon from './EngagementIcon.vue'
    import {getColorClass} from '../reusables/GetColorClass.js'
    import EngagementDefinitions from './EngagementDefinitions.vue'
    import Modal from './Modal.vue';
    import ResiliencyBadgeDetails from './ResiliencyBadgeDetails.vue';

    const props = defineProps({
        org: {},
        isInModal: Boolean,
        showPrevNext: { type: Boolean, default: false},
        disablePrev: { type: Boolean, default: false },
        disableNext: { type: Boolean, default: false },
    })

    const link = ref(null) // Template ref
    const showInfoModal = ref(false)

    const isProvider = props.org.type.includes('provider') ? true : false
    const badgesSupported = ref([])

    const emits = defineEmits(['closeModal', 'prevNextClicked'])

    onMounted(()=>{
        window.addEventListener('keydown', handleArrowPress);
        if(isProvider) {
            let resiliencySupportLevel = props.org.engagement.badges.resiliency.support_level
            let transparencySupportLevel = props.org.engagement.badges.transparency.support_level

            // console.log({
            //     'resiliencySupportLevel' : resiliencySupportLevel,
            //     'transparencySupportLevel' : transparencySupportLevel
            // });
            if(supportsBadge(transparencySupportLevel)) {
                badgesSupported.value.push({'Transparency': transparencySupportLevel})
            }
            if(supportsBadge(resiliencySupportLevel)) {
                badgesSupported.value.push({'Resiliency': resiliencySupportLevel})
            }
        }
    })
    onBeforeUnmount(()=>{
        window.removeEventListener('keydown', handleArrowPress);
    })

    const handleBackClick = () => {
        if (props.isInModal) {
            emits('closeModal')
        }
        else {
            const href = link.value.getAttribute('href')
            window.location.assign(href)
        }
    }
    const capFirstLetter = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1)
    }
    const getTypeList = (typeArr) => {
        if(typeArr.length === 1) {
            return capFirstLetter(typeArr[0])
        } else {
            let str = ''
            for (let i = 0; i < typeArr.length; i++) {
                if(i === 0) {
                    str += capFirstLetter(typeArr[i])
                } else if ( i === (typeArr.length - 1)) {
                    if(i > 1) {
                        str += ', and ' + typeArr[i]
                    } else {
                        str += 'and ' + typeArr[i]
                    }
                } else {
                    str += ', ' + typeArr[i]
                }
            }
            return str
        }
    }
    const handleArrowPress = (e) => {
        if (e.key === 'ArrowRight') {
            handlePrevNextClick('next')
        } else if (e.key === 'ArrowLeft') {
            handlePrevNextClick('prev')
        }
    }
    const handlePrevNextClick = (direction) => {
        emits('prevNextClicked', direction)
    }

    const getTranspYearBadge = (year) => {
        return '/wp-content/themes/hirc-custom/public/img/hirc-badge-transparency-' + year + '.svg'
    }
    
    const showBadgesSection = () => {
        return props.org.engagement?.badges?.transparency?.has_badge || props.org.engagement?.badges?.resiliency?.has_badge || isProvider.value
    }

    const supportsBadge = (supportLevel) => {
        return supportLevel === 'engaged' || supportLevel === 'adopted';
    }
</script>

<style scoped>
    .has-gray-light-color, .has-gray-color {
        color: #acacac !important;
    }
</style>